import React from "react";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  ActionButton,
  ActionButtonContainer,
} from "components/AgGrid/ActionButton";

import { SaleLotModalSection } from "constants/navigation";
import { saleLotStatuses } from "constants/sale";

import { openEditSaleLotModal } from "lib/navigation";

export function actionsColumnRenderer({ data }) {
  if (!data) {
    return null;
  }

  const { id: saleLotId, status } = data;

  const onOpenEditSaleLotModal = () => {
    openEditSaleLotModal(
      saleLotId,
      status === saleLotStatuses.SOLD
        ? SaleLotModalSection.SELLING
        : SaleLotModalSection.GENERAL,
    );
  };
  return (
    <ActionButtonContainer>
      <ActionButton
        data-tour="action-edit-lot"
        onClick={onOpenEditSaleLotModal}
      >
        <FontAwesomeIcon icon={faPencil} />
        &nbsp;Edit
      </ActionButton>
    </ActionButtonContainer>
  );
}
